import EdoPlatforms from './EdoPlatforms';

export default EdoPlatforms;
